<!--
/*******************************************************************************
*@ 컴포넌트명   : QrcodeGenerator.vue
*@ 컴포넌트설명 : QrcodeGenerator
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div>
      <qrcode-vue
        :value="value"
        :size="size"
        :level="level"
        :margin="margin"
        :background="background"
        :foregroung="foreground"
      />
    </div>
  </article>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: { QrcodeVue },
  props: {
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
    level: {
      type: String,
      required: false,
      default: "H",
    },
    margin: {
      type: Number,
      required: false,
      default: 10,
    },
    background: {
      type: String,
      required: false,
      default: "#ffffff",
    },
    foreground: {
      type: String,
      required: false,
      default: "#000000",
    },
  },
  validations: {},
  created() {},
  mounted() {},
  updated() {},
  data() {},
  computed: {},
  methods: {},
};
</script>
